import { I18nUtil } from "@utils/i18n";
import { Icon } from "@ospweb/sdk-ui";
import { ShellLink } from "@components/ShellNavigation/ShellAwareLink";
import NextImage from "../NextImage";
import Translations from "@translate/components/Chat/RelatedAccounts";
import { cn } from "utils";
import { motion } from "motion/react";

const I18n = I18nUtil.createScoped(Translations);

export interface User {
  avatar: string;
  desc: string;
  handle: string;
  name: string;
  source: string;
}

export default function RelatedAccounts({ data }: { data: User[] }) {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 1.5 } }}
      className="flex-1"
    >
      <div className="flex-1">
        <div className="flex items-center gap-2">
          <Icon
            name="user-circle"
            color="white"
            className="!text-content_secondary"
          />
          <div className=" body_medium_m py-4">
            {I18n.t("Related accounts")}
          </div>
        </div>
        <div className="flex gap-4 overflow-x-scroll no-scrollbar hot-search-linear-gradient">
          {data.map((i, index) => (
            <ShellLink
              aria-label="Related Accounts"
              data-openreplay-label="chatbox_relatedaccounts_open"
              id="lnk-related-accounts"
              target="_blank"
              className={cn(
                "flex flex-col items-start gap-2 p-3 rounded-2xl bg-background_white_overlay5 hover:bg-background_white_overlay10 backdrop-blur-30",
                "w-[246px] min-w-[246px] max-h-[158px]",
              )}
              href={`https://x.com/${i.handle}`}
              key={index}
            >
              <NextImage
                src={i.avatar}
                alt={i.handle}
                width={40}
                height={40}
                className="rounded-full"
              />
              <div className="flex flex-col items-start justify-center self-stretch w-full body_s">
                <div className="inline-flex flex-col items-start  ">
                  <div className=" w-fit mt-2 body_medium_m">{i.name}</div>

                  <div className="inline-flex items-center justify-center gap-0.5 text-content_tertiary">
                    <div className="body_s">{i.handle}</div>
                    {/* <div className="text-size-xs mx-0.5 pt-[2px]">•</div>
                      <Icon
                        name="user-circle"
                        className="text-content_tertiary"
                        size={12}
                      />
                      <div>22K</div> */}
                  </div>
                </div>

                <p
                  className="text-content_tertiary line-clamp-2"
                  dangerouslySetInnerHTML={{ __html: i.desc || "" }}
                />
              </div>
            </ShellLink>
          ))}
        </div>
      </div>
    </motion.div>
  );
}
